import { CaseRelationModel } from "../../desktop/models/case-relation";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: CaseRelationModel
})
export class DocumentRelationCollection extends Backbone.Collection<CaseRelationModel> {
    constructor(options?) {
        super(options);
    }

    public add(newModel: any, options?: Backbone.AddOptions): any {
        const isDupe = this.any((model) => {
            return model.Id === newModel.Id;
        });
        return isDupe ? false : super.add.call(this, newModel);
    }

    public reset(models?: CaseRelationModel[], options?: any): CaseRelationModel[] {
        return models;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/document-relations.ts